// components/drawers/DrawerImpostazioni.tsx
"use client";
import { useEffect, useState } from "react";
import { useAuth } from "@/hooks/useAuth";

interface DrawerImpostazioniProps {
  onClose: () => void;
}

export default function DrawerImpostazioni({ onClose }: DrawerImpostazioniProps) {
  const { profile } = useAuth();
  const [themeExpanded, setThemeExpanded] = useState(false);
  const [theme, setTheme] = useState<'light' | 'dark'>('light');

  useEffect(() => {
    const saved = localStorage.getItem('bandoinail_settings');
    if (saved) {
      try {
        const data = JSON.parse(saved);
        if (data.theme === 'dark' || data.theme === 'light') {
          setTheme(data.theme);
          applyTheme(data.theme);
        }
      } catch {}
    }
  }, []);

  function applyTheme(t: 'light' | 'dark') {
    if (t === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }

  function handleThemeChange(t: 'light' | 'dark') {
    setTheme(t);
    const saved = localStorage.getItem('bandoinail_settings');
    const data = saved ? JSON.parse(saved) : {};
    localStorage.setItem('bandoinail_settings', JSON.stringify({ ...data, theme: t }));
    applyTheme(t);
  }

  return (
    <>
      <div className="topbar">
        <button className="iconbtn" onClick={onClose}>✕</button>
        <div className="title">Impostazioni</div>
        <div className="spacer" />
      </div>

      <div className="list">
        {/* Profilo */}
        {profile && (
          <div className="row" style={{ borderBottom: '1px solid #e2e8f0', paddingBottom: 12 }}>
            <span style={{ fontWeight: 500 }}>👤 Profilo</span>
            <div style={{ marginTop: 8, fontSize: 13, color: '#334155' }}>
              <div style={{ fontWeight: 600 }}>{profile.first_name} {profile.last_name}</div>
              <div style={{ color: '#64748b', marginTop: 2 }}>{profile.email}</div>
            </div>
          </div>
        )}

        {/* Tema */}
        <div className="row" style={{ borderBottom: '1px solid #e2e8f0', paddingBottom: 12 }}>
          <div
            onClick={() => setThemeExpanded(!themeExpanded)}
            style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
          >
            <span style={{ fontWeight: 500 }}>🎨 Tema</span>
            <span style={{ color: '#64748b' }}>{themeExpanded ? '▲' : '▼'}</span>
          </div>

          {themeExpanded && (
            <div style={{ marginTop: 12, paddingLeft: 8 }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, cursor: 'pointer' }}>
                <input
                  type="radio"
                  name="theme"
                  checked={theme === 'light'}
                  onChange={() => handleThemeChange('light')}
                />
                <span style={{ fontSize: 14 }}>☀️ Sfondo chiaro</span>
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                <input
                  type="radio"
                  name="theme"
                  checked={theme === 'dark'}
                  onChange={() => handleThemeChange('dark')}
                />
                <span style={{ fontSize: 14 }}>🌙 Sfondo scuro</span>
              </label>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
